var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('contract-comp',{attrs:{"deptName":"崂山书院文化发展公司"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }